<template>
  <action-person-template :action="action" column="person" grid="person" title="Joueur entrant"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonSubstitute',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
